export default "__VITE_ASSET__BoM_SXO0__"